<template>
	<v-data-table :items="samples" :headers="headers" :loading="loading">
		<template v-slot:item="props">
			<tr>
				<td>
					<v-btn text icon color="primary" @click="select(props.item)">
						<v-icon>fal fa-plus-circle</v-icon>
					</v-btn>
				</td>
				<td><v-icon small>far fa-heart-rate fa-fw</v-icon> {{props.item.zip.identifier}}</td>
				<td>{{formatDateTime(props.item.zip.lastModified)}}</td>
				<td>{{fileSize(props.item.zip.size)}}</td>
				<td><v-icon small v-if="props.item.pkgs.length > 0">fal fa-box-heart fa-fw</v-icon> {{props.item.pkgs.length}}</td>
			</tr>
		</template>
		<template v-slot:no-data>
			<v-alert color="info">
				No files
			</v-alert>
		</template>
	</v-data-table>
</template>

<script>
import { fileSize } from "humanize-plus";
import api from "../api";

export default {
	props: {
		selectable: Boolean,
	},
	data() {
		return {
			headers: [
				{ text: "", value: "zip.identifier", sortable: false },
				{ text: "Name", value: "zip.identifier" },
				{ text: "Date", value: "zip.lastModified" },
				{ text: "Size", value: "zip.size" },
				{ text: "PKG Count", value: "zip.pkgs.length" },
			],
			samples: [],
			loading: true,
		};
	},
	created() {
		api.samples().then((r) => {
			this.samples = r.data;
			this.loading = false;
			this.$emit("loaded", r.data);
		}, (e) => {
			this.showError(e);
			this.loading = false;
		});
	},
	methods: {
		fileSize,
		select(item) {
			this.$emit("selected", item);
		},
	},
};
</script>
